// Fragment "pathways": every learner-facing string of Pathways v3
// (docs/pathways-module/pathways-api-contract.md §9): the /parcours cards and join form
// (public/Parcours.jsx, public/pathways/PathwayCard.jsx, JoinForm.jsx), the pathway page
// (public/PathwayMember.jsx, PathwayDetail.jsx, PathwayHomeView.jsx), the step screen
// (PathwayStep.jsx, StepScreenView.jsx, StepQuiz.jsx, StepVideo.jsx), the reminder
// opt-out (NudgesOff.jsx) and "My pathways" in the client portal (PortalPathways.jsx).
// Refusal sentences keyed by error code live in common/pathwayErrors.js.
// Merged in ./index.js.
export default {
  fr: {
    // ── shared ──
    "pathways.retry": "Réessayer",
    "pathways.loadFailed": "Impossible de charger ce parcours. Réessayez dans un instant.",
    "pathways.percent": "{percent} %",
    "pathways.levelHeading": "Niveau {n} · {title}",
    "pathways.type.successive": "étape par étape",
    "pathways.type.alternative": "flexible",
    "pathways.type.levelsOne": "1 niveau",
    "pathways.type.levelsMany": "{n} niveaux",
    "pathways.length.minutes": "~{n} min",
    "pathways.length.hoursOne": "~1 heure au total",
    "pathways.length.hoursMany": "~{n} heures au total",
    "pathways.state.done": "Terminée",
    "pathways.state.current": "Étape en cours",
    "pathways.state.locked": "Verrouillée",

    // ── /parcours ──
    "pathways.catalogue.heading": "Parcours",
    "pathways.catalogue.subheading": "Avancez étape par étape, à votre rythme, avec un chemin clair du début à la fin.",
    "pathways.catalogue.empty": "Aucun parcours ouvert pour l'instant. Revenez bientôt.",
    "pathways.catalogue.loadFailed": "Impossible de charger les parcours. Réessayez dans un instant.",
    "pathways.card.objectives": "À la fin, vous saurez :",
    "pathways.card.free": "Gratuit",
    "pathways.card.spotsOne": "1 place restante",
    "pathways.card.spotsMany": "{n} places restantes",
    "pathways.card.full": "Complet",
    "pathways.card.join": "Rejoindre le parcours",
    "pathways.card.startsOn": "Début le {date}",

    // ── the join form ──
    "pathways.join.title": "Rejoindre le parcours",
    "pathways.join.name": "Nom",
    "pathways.join.email": "E-mail",
    "pathways.join.emailInvalid": "Vérifiez votre adresse e-mail",
    "pathways.join.submit": "S'inscrire",
    "pathways.join.error": "L'inscription n'a pas abouti. Réessayez dans un instant.",
    "pathways.join.enrolledToast": "Inscription confirmée. Bon parcours !",
    "pathways.join.alreadyToast": "Vous êtes déjà inscrit·e à ce parcours.",

    // ── the pathway page, not joined ──
    "pathways.detail.back": "Tous les parcours",
    "pathways.detail.outline": "Au programme",
    "pathways.checkout.confirming": "Confirmation de votre paiement…",
    "pathways.checkout.slow": "Votre paiement a bien été reçu. Votre accès est en cours d'ouverture : actualisez cette page dans un instant.",
    "pathways.checkout.recheck": "Vérifier à nouveau",
    "pathways.checkout.unpaid": "Le paiement n'a pas été finalisé. Rien ne vous a été facturé.",
    "pathways.checkout.cancelled": "Paiement annulé. Rien ne vous a été facturé ; vous pouvez rejoindre le parcours quand vous le souhaitez.",
    "pathways.checkout.paidToast": "Paiement confirmé. Bienvenue dans le parcours !",
    "pathways.notFound.title": "Parcours introuvable",
    "pathways.notFound.body": "Ce parcours n'existe pas, ou vous ne l'avez pas rejoint.",
    "pathways.notFound.signIn": "Se connecter",
    "pathways.notFound.account": "Mon espace",
    "pathways.notFound.browse": "Voir les parcours",

    // ── the pathway home ──
    "pathways.home.objectives": "Objectifs",
    "pathways.home.progress": "{done} étapes sur {total}",
    "pathways.home.progressLabel": "Progression dans le parcours",
    "pathways.home.optional": "Facultative",
    "pathways.home.unlocksAfter": "Se débloque après {title}",
    "pathways.home.minutes": "~{n} min",
    "pathways.home.continue": "Continuer · {title}",
    "pathways.home.completed": "Vous avez terminé le parcours",
    "pathways.home.certificateInbox": "Votre certificat vous attend aussi dans votre boîte de réception.",
    "pathways.home.downloadCertificate": "Télécharger le certificat",
    "pathways.home.prompts": "Pistes de la semaine",
    "pathways.home.prompt": "Semaine {week} · « {text} »",
    "pathways.home.archived": "Ce parcours est archivé : vous pouvez le revoir, mais plus y avancer.",

    // ── the step screen ──
    "pathways.step.eyebrow": "Étape {n} sur {total}",
    "pathways.step.eyebrowLevel": "Niveau {level} · Étape {n} sur {total}",
    "pathways.step.back": "Retour à {title}",
    "pathways.step.backHome": "Retour au parcours",
    "pathways.step.done": "Terminée",
    "pathways.step.preview": "Aperçu : la validation des étapes est désactivée.",
    "pathways.step.autoComplete": "Se valide automatiquement à 90 % visionnés",
    "pathways.step.videoUntracked": "Nous ne pouvons pas suivre la lecture de cette vidéo ici. Une fois regardée, marquez-la comme terminée.",
    "pathways.step.markDone": "Marquer comme terminée",
    "pathways.step.completeFailed": "Cette étape n'a pas pu être enregistrée. Réessayez.",
    "pathways.step.retrySave": "Réessayer l'enregistrement",
    "pathways.step.next": "Suivante : {title}",
    "pathways.step.nextLocked": "Suivante : {title} (verrouillée)",
    "pathways.step.resources": "Ressources",
    "pathways.step.videoUnavailable": "Cette vidéo ne peut pas être lue ici.",
    "pathways.step.loadFailed": "Impossible de charger cette étape. Réessayez dans un instant.",
    "pathways.step.lockedTitle": "Cette étape n'est pas encore ouverte",
    "pathways.step.lockedBody": "Terminez d'abord les étapes qui la précèdent.",
    "pathways.step.signInTitle": "Connectez-vous pour continuer",
    "pathways.step.signInBody": "Cette étape fait partie d'un parcours : connectez-vous avec l'adresse e-mail de votre inscription.",
    "pathways.step.levelCompleted": "Niveau terminé !",
    "pathways.step.pathwayCompleted": "Vous avez terminé le parcours !",

    // ── quiz ──
    "pathways.quiz.threshold": "Score requis : {n} %",
    "pathways.quiz.submit": "Envoyer mes réponses",
    "pathways.quiz.answerAll": "Répondez à toutes les questions avant d'envoyer.",
    "pathways.quiz.passed": "Réussi · {score} %",
    "pathways.quiz.failed": "Pas encore réussi · {score} % ({threshold} % requis)",
    "pathways.quiz.alreadyPassed": "Quiz réussi · meilleur score {score} %",
    "pathways.quiz.retry": "Réessayer",
    "pathways.quiz.attempts": "Tentatives : {n}",
    "pathways.quiz.attemptsBest": "Tentatives : {n} · meilleur score {best} %",
    "pathways.quiz.correct": "Bonne réponse",
    "pathways.quiz.incorrect": "Mauvaise réponse",
    "pathways.quiz.submitFailed": "Vos réponses n'ont pas pu être envoyées. Réessayez dans un instant.",

    // ── phase 3 step kinds (contract §10) ──
    "pathways.kind.video": "Vidéo",
    "pathways.kind.reading": "Lecture",
    "pathways.kind.practice": "Pratique",
    "pathways.kind.quiz": "Quiz",
    "pathways.kind.live": "Séance en direct",
    "pathways.kind.course": "Formation",

    // ── practice ──
    "pathways.practice.textLabel": "Vos notes",
    "pathways.practice.photoLabel": "Ajouter une photo (facultatif)",
    "pathways.practice.photoHint": "JPEG, PNG ou WebP, 10 Mo maximum",
    "pathways.practice.photoRemove": "Retirer la photo",
    "pathways.practice.photoType": "Ce type de photo n'est pas accepté. Choisissez une image JPEG, PNG ou WebP.",
    "pathways.practice.photoTooLarge": "Cette photo dépasse 10 Mo. Choisissez-en une plus légère.",
    "pathways.practice.empty": "Écrivez une note ou ajoutez une photo avant d'envoyer.",
    "pathways.practice.submit": "Envoyer",
    "pathways.practice.submitted": "Envoyé. Votre praticien·ne va le consulter.",
    "pathways.practice.submitFailed": "Votre envoi n'a pas abouti. Réessayez dans un instant.",
    "pathways.practice.resubmitHint": "Vous pouvez envoyer une nouvelle réponse à tout moment : elle repart chez votre praticien·ne pour relecture.",
    "pathways.practice.submissions": "Vos envois",
    "pathways.practice.submittedOn": "Envoyé le {date}",
    "pathways.practice.status.pending": "En attente de relecture",
    "pathways.practice.status.approved": "Validé",
    "pathways.practice.status.feedback_sent": "Retour reçu",
    "pathways.practice.status.superseded": "Remplacé par un envoi plus récent",
    "pathways.practice.feedback": "Retour de votre praticien·ne",
    "pathways.practice.photoAlt": "Votre photo",

    // ── live session ──
    "pathways.live.duration": "{n} min",
    "pathways.live.zone": "Heure affichée dans votre fuseau horaire ({zone})",
    "pathways.live.timeTbd": "La date de cette séance sera annoncée prochainement.",
    "pathways.live.addToCalendar": "Ajouter à mon agenda",
    "pathways.live.attended": "Présence confirmée ✓",
    "pathways.live.attendanceHint": "Votre praticien·ne note les présences après la séance : l'étape se valide à ce moment-là.",
    "pathways.live.free": "Gratuit",
    "pathways.live.book": "Réserver cette séance",
    "pathways.live.bookedFor": "Réservée pour le {when}",
    "pathways.live.completesOnBooking": "Se valide lorsque votre séance est marquée comme terminée",
    "pathways.live.completedSession": "Séance du {when} terminée",
    "pathways.live.serviceUnavailable": "Ce type de séance ne peut pas être réservé pour le moment. Contactez votre praticien·ne.",

    // ── course ──
    "pathways.course.lessons": "{done} leçons sur {total}",
    "pathways.course.open": "Ouvrir la formation",
    "pathways.course.unavailable": "Cette formation n'est pas disponible pour le moment.",
    "pathways.course.completesHint": "Se valide lorsque vous avez terminé toutes les leçons de la formation.",
    "pathways.course.backToPathway": "Retour au parcours",

    // ── reminders opt-out ──
    "pathways.nudges.title": "Rappels",
    "pathways.nudges.working": "Désactivation des rappels…",
    "pathways.nudges.done": "Vous ne recevrez plus de rappels pour {title}.",
    "pathways.nudges.invalid": "Ce lien n'est pas valide. Utilisez le lien du dernier e-mail de rappel reçu.",
    "pathways.nudges.error": "Les rappels n'ont pas pu être désactivés. Réessayez dans un instant.",
    "pathways.nudges.account": "Mon espace",

    // ── client portal ──
    "portal.pathways": "Mes parcours",
    "portal.pathways.empty": "Vous ne suivez aucun parcours pour l'instant.",
    "portal.pathways.browse": "Découvrir les parcours",
    "portal.pathways.loadFailed": "Impossible de charger vos parcours. Réessayez dans un instant.",
    "portal.pathways.open": "Ouvrir le parcours",
    "portal.pathways.completed": "Terminé",
    "portal.pathways.archived": "Archivé",
  },
  en: {
    "pathways.retry": "Try again",
    "pathways.loadFailed": "This pathway could not be loaded. Please try again in a moment.",
    "pathways.percent": "{percent}%",
    "pathways.levelHeading": "Level {n} · {title}",
    "pathways.type.successive": "step by step",
    "pathways.type.alternative": "flexible",
    "pathways.type.levelsOne": "1 level",
    "pathways.type.levelsMany": "{n} levels",
    "pathways.length.minutes": "~{n} min",
    "pathways.length.hoursOne": "~1 hour total",
    "pathways.length.hoursMany": "~{n} hours total",
    "pathways.state.done": "Done",
    "pathways.state.current": "Current step",
    "pathways.state.locked": "Locked",

    "pathways.catalogue.heading": "Pathways",
    "pathways.catalogue.subheading": "Move forward step by step, at your own pace, on a clear path from start to finish.",
    "pathways.catalogue.empty": "No pathway is open right now. Check back soon.",
    "pathways.catalogue.loadFailed": "The pathways could not be loaded. Please try again in a moment.",
    "pathways.card.objectives": "By the end you will be able to:",
    "pathways.card.free": "Free",
    "pathways.card.spotsOne": "1 spot left",
    "pathways.card.spotsMany": "{n} spots left",
    "pathways.card.full": "Full",
    "pathways.card.join": "Join the pathway",
    "pathways.card.startsOn": "Starts {date}",

    "pathways.join.title": "Join the pathway",
    "pathways.join.name": "Name",
    "pathways.join.email": "Email",
    "pathways.join.emailInvalid": "Check your email address",
    "pathways.join.submit": "Enroll",
    "pathways.join.error": "Enrollment did not go through. Please try again in a moment.",
    "pathways.join.enrolledToast": "You're enrolled. Enjoy the pathway!",
    "pathways.join.alreadyToast": "You're already enrolled in this pathway.",

    "pathways.detail.back": "All pathways",
    "pathways.detail.outline": "What's inside",
    "pathways.checkout.confirming": "Confirming your payment…",
    "pathways.checkout.slow": "Your payment went through. Your access is being set up: refresh this page in a moment.",
    "pathways.checkout.recheck": "Check again",
    "pathways.checkout.unpaid": "The payment was not completed. You have not been charged.",
    "pathways.checkout.cancelled": "Checkout cancelled. You have not been charged; you can join whenever you are ready.",
    "pathways.checkout.paidToast": "Payment confirmed. Welcome to the pathway!",
    "pathways.notFound.title": "Pathway not found",
    "pathways.notFound.body": "This pathway does not exist, or you have not joined it.",
    "pathways.notFound.signIn": "Sign in",
    "pathways.notFound.account": "My account",
    "pathways.notFound.browse": "See the pathways",

    "pathways.home.objectives": "Objectives",
    "pathways.home.progress": "{done} of {total} steps",
    "pathways.home.progressLabel": "Pathway progress",
    "pathways.home.optional": "Optional",
    "pathways.home.unlocksAfter": "Unlocks after {title}",
    "pathways.home.minutes": "~{n} min",
    "pathways.home.continue": "Continue · {title}",
    "pathways.home.completed": "You completed the pathway",
    "pathways.home.certificateInbox": "Your certificate is also in your inbox.",
    "pathways.home.downloadCertificate": "Download certificate",
    "pathways.home.prompts": "Weekly prompts",
    "pathways.home.prompt": "Week {week} · “{text}”",
    "pathways.home.archived": "This pathway is archived: you can review it, but no longer move forward in it.",

    "pathways.step.eyebrow": "Step {n} of {total}",
    "pathways.step.eyebrowLevel": "Level {level} · Step {n} of {total}",
    "pathways.step.back": "Back to {title}",
    "pathways.step.backHome": "Back to the pathway",
    "pathways.step.done": "Done",
    "pathways.step.preview": "Preview: completing steps is turned off.",
    "pathways.step.autoComplete": "Auto-completes at 90% watched",
    "pathways.step.videoUntracked": "We can't follow this video's progress here. Once you have watched it, mark it as done.",
    "pathways.step.markDone": "Mark as done",
    "pathways.step.completeFailed": "This step could not be saved. Please try again.",
    "pathways.step.retrySave": "Try saving again",
    "pathways.step.next": "Next: {title}",
    "pathways.step.nextLocked": "Next: {title} (locked)",
    "pathways.step.resources": "Resources",
    "pathways.step.videoUnavailable": "This video cannot be played here.",
    "pathways.step.loadFailed": "This step could not be loaded. Please try again in a moment.",
    "pathways.step.lockedTitle": "This step is not open yet",
    "pathways.step.lockedBody": "Finish the steps before it first.",
    "pathways.step.signInTitle": "Sign in to continue",
    "pathways.step.signInBody": "This step is part of a pathway: sign in with the email address you enrolled with.",
    "pathways.step.levelCompleted": "Level complete!",
    "pathways.step.pathwayCompleted": "You completed the pathway!",

    "pathways.quiz.threshold": "Pass mark: {n}%",
    "pathways.quiz.submit": "Submit answers",
    "pathways.quiz.answerAll": "Answer every question before submitting.",
    "pathways.quiz.passed": "Passed · {score}%",
    "pathways.quiz.failed": "Not passed yet · {score}% ({threshold}% needed)",
    "pathways.quiz.alreadyPassed": "Quiz passed · best score {score}%",
    "pathways.quiz.retry": "Try again",
    "pathways.quiz.attempts": "Attempts: {n}",
    "pathways.quiz.attemptsBest": "Attempts: {n} · best score {best}%",
    "pathways.quiz.correct": "Correct",
    "pathways.quiz.incorrect": "Incorrect",
    "pathways.quiz.submitFailed": "Your answers could not be sent. Please try again in a moment.",

    // ── phase 3 step kinds (contract §10) ──
    "pathways.kind.video": "Video",
    "pathways.kind.reading": "Reading",
    "pathways.kind.practice": "Practice",
    "pathways.kind.quiz": "Quiz",
    "pathways.kind.live": "Live session",
    "pathways.kind.course": "Course",

    // ── practice ──
    "pathways.practice.textLabel": "Your notes",
    "pathways.practice.photoLabel": "Add a photo (optional)",
    "pathways.practice.photoHint": "JPEG, PNG or WebP, up to 10 MB",
    "pathways.practice.photoRemove": "Remove photo",
    "pathways.practice.photoType": "This photo type is not supported. Choose a JPEG, PNG or WebP image.",
    "pathways.practice.photoTooLarge": "This photo is larger than 10 MB. Choose a smaller one.",
    "pathways.practice.empty": "Write a note or add a photo before submitting.",
    "pathways.practice.submit": "Submit",
    "pathways.practice.submitted": "Submitted. Your practitioner will review it.",
    "pathways.practice.submitFailed": "Your submission could not be sent. Please try again in a moment.",
    "pathways.practice.resubmitHint": "You can send a new submission at any time; it goes back to your practitioner for review.",
    "pathways.practice.submissions": "Your submissions",
    "pathways.practice.submittedOn": "Sent {date}",
    "pathways.practice.status.pending": "Awaiting review",
    "pathways.practice.status.approved": "Approved",
    "pathways.practice.status.feedback_sent": "Feedback received",
    "pathways.practice.status.superseded": "Replaced by a newer submission",
    "pathways.practice.feedback": "Your practitioner's feedback",
    "pathways.practice.photoAlt": "Your photo",

    // ── live session ──
    "pathways.live.duration": "{n} min",
    "pathways.live.zone": "Shown in your time zone ({zone})",
    "pathways.live.timeTbd": "The date of this session will be announced soon.",
    "pathways.live.addToCalendar": "Add to calendar",
    "pathways.live.attended": "Attended ✓",
    "pathways.live.attendanceHint": "Your practitioner marks attendance after the session; the step completes then.",
    "pathways.live.free": "Free",
    "pathways.live.book": "Book this session",
    "pathways.live.bookedFor": "Booked for {when}",
    "pathways.live.completesOnBooking": "Completes when your session is marked complete",
    "pathways.live.completedSession": "Session on {when} completed",
    "pathways.live.serviceUnavailable": "This session type cannot be booked right now. Please contact your practitioner.",

    // ── course ──
    "pathways.course.lessons": "{done} of {total} lessons",
    "pathways.course.open": "Open course",
    "pathways.course.unavailable": "This course is not available right now.",
    "pathways.course.completesHint": "Completes when you finish every lesson of the course.",
    "pathways.course.backToPathway": "Back to pathway",

    "pathways.nudges.title": "Reminders",
    "pathways.nudges.working": "Turning reminders off…",
    "pathways.nudges.done": "You won't receive reminders for {title} any more.",
    "pathways.nudges.invalid": "This link is not valid. Use the link in the latest reminder email you received.",
    "pathways.nudges.error": "Reminders could not be turned off. Please try again in a moment.",
    "pathways.nudges.account": "My account",

    "portal.pathways": "My pathways",
    "portal.pathways.empty": "You are not following any pathway yet.",
    "portal.pathways.browse": "Browse pathways",
    "portal.pathways.loadFailed": "Your pathways could not be loaded. Please try again in a moment.",
    "portal.pathways.open": "Open the pathway",
    "portal.pathways.completed": "Completed",
    "portal.pathways.archived": "Archived",
  },
  es: {
    "pathways.retry": "Reintentar",
    "pathways.loadFailed": "No se pudo cargar este itinerario. Inténtalo de nuevo en un momento.",
    "pathways.percent": "{percent} %",
    "pathways.levelHeading": "Nivel {n} · {title}",
    "pathways.type.successive": "paso a paso",
    "pathways.type.alternative": "flexible",
    "pathways.type.levelsOne": "1 nivel",
    "pathways.type.levelsMany": "{n} niveles",
    "pathways.length.minutes": "~{n} min",
    "pathways.length.hoursOne": "~1 hora en total",
    "pathways.length.hoursMany": "~{n} horas en total",
    "pathways.state.done": "Completado",
    "pathways.state.current": "Paso actual",
    "pathways.state.locked": "Bloqueado",

    "pathways.catalogue.heading": "Itinerarios",
    "pathways.catalogue.subheading": "Avanza paso a paso, a tu ritmo, por un camino claro de principio a fin.",
    "pathways.catalogue.empty": "No hay ningún itinerario abierto por ahora. Vuelve pronto.",
    "pathways.catalogue.loadFailed": "No se pudieron cargar los itinerarios. Inténtalo de nuevo en un momento.",
    "pathways.card.objectives": "Al terminar, sabrás:",
    "pathways.card.free": "Gratis",
    "pathways.card.spotsOne": "Queda 1 plaza",
    "pathways.card.spotsMany": "Quedan {n} plazas",
    "pathways.card.full": "Completo",
    "pathways.card.join": "Unirme al itinerario",
    "pathways.card.startsOn": "Empieza el {date}",

    "pathways.join.title": "Unirme al itinerario",
    "pathways.join.name": "Nombre",
    "pathways.join.email": "Correo electrónico",
    "pathways.join.emailInvalid": "Revisa tu dirección de correo",
    "pathways.join.submit": "Inscribirme",
    "pathways.join.error": "La inscripción no se completó. Inténtalo de nuevo en un momento.",
    "pathways.join.enrolledToast": "Inscripción confirmada. ¡Disfruta del itinerario!",
    "pathways.join.alreadyToast": "Ya estás inscrito/a en este itinerario.",

    "pathways.detail.back": "Todos los itinerarios",
    "pathways.detail.outline": "Contenido",
    "pathways.checkout.confirming": "Confirmando tu pago…",
    "pathways.checkout.slow": "Tu pago se ha recibido. Estamos abriendo tu acceso: actualiza esta página en un momento.",
    "pathways.checkout.recheck": "Comprobar de nuevo",
    "pathways.checkout.unpaid": "El pago no se completó. No se te ha cobrado nada.",
    "pathways.checkout.cancelled": "Pago cancelado. No se te ha cobrado nada; puedes unirte cuando quieras.",
    "pathways.checkout.paidToast": "Pago confirmado. ¡Te damos la bienvenida al itinerario!",
    "pathways.notFound.title": "Itinerario no encontrado",
    "pathways.notFound.body": "Este itinerario no existe o no te has unido a él.",
    "pathways.notFound.signIn": "Iniciar sesión",
    "pathways.notFound.account": "Mi cuenta",
    "pathways.notFound.browse": "Ver los itinerarios",

    "pathways.home.objectives": "Objetivos",
    "pathways.home.progress": "{done} de {total} pasos",
    "pathways.home.progressLabel": "Progreso en el itinerario",
    "pathways.home.optional": "Opcional",
    "pathways.home.unlocksAfter": "Se desbloquea después de {title}",
    "pathways.home.minutes": "~{n} min",
    "pathways.home.continue": "Continuar · {title}",
    "pathways.home.completed": "Has completado el itinerario",
    "pathways.home.certificateInbox": "Tu certificado también está en tu bandeja de entrada.",
    "pathways.home.downloadCertificate": "Descargar el certificado",
    "pathways.home.prompts": "Propuestas semanales",
    "pathways.home.prompt": "Semana {week} · «{text}»",
    "pathways.home.archived": "Este itinerario está archivado: puedes repasarlo, pero ya no avanzar en él.",

    "pathways.step.eyebrow": "Paso {n} de {total}",
    "pathways.step.eyebrowLevel": "Nivel {level} · Paso {n} de {total}",
    "pathways.step.back": "Volver a {title}",
    "pathways.step.backHome": "Volver al itinerario",
    "pathways.step.done": "Completado",
    "pathways.step.preview": "Vista previa: completar pasos está desactivado.",
    "pathways.step.autoComplete": "Se completa automáticamente al 90 % visto",
    "pathways.step.videoUntracked": "No podemos seguir la reproducción de este vídeo aquí. Cuando lo hayas visto, márcalo como hecho.",
    "pathways.step.markDone": "Marcar como hecho",
    "pathways.step.completeFailed": "No se pudo guardar este paso. Inténtalo de nuevo.",
    "pathways.step.retrySave": "Volver a guardar",
    "pathways.step.next": "Siguiente: {title}",
    "pathways.step.nextLocked": "Siguiente: {title} (bloqueado)",
    "pathways.step.resources": "Recursos",
    "pathways.step.videoUnavailable": "Este vídeo no se puede reproducir aquí.",
    "pathways.step.loadFailed": "No se pudo cargar este paso. Inténtalo de nuevo en un momento.",
    "pathways.step.lockedTitle": "Este paso aún no está abierto",
    "pathways.step.lockedBody": "Termina primero los pasos anteriores.",
    "pathways.step.signInTitle": "Inicia sesión para continuar",
    "pathways.step.signInBody": "Este paso forma parte de un itinerario: inicia sesión con el correo con el que te inscribiste.",
    "pathways.step.levelCompleted": "¡Nivel completado!",
    "pathways.step.pathwayCompleted": "¡Has completado el itinerario!",

    "pathways.quiz.threshold": "Nota mínima: {n} %",
    "pathways.quiz.submit": "Enviar respuestas",
    "pathways.quiz.answerAll": "Responde a todas las preguntas antes de enviar.",
    "pathways.quiz.passed": "Aprobado · {score} %",
    "pathways.quiz.failed": "Aún no aprobado · {score} % (se necesita {threshold} %)",
    "pathways.quiz.alreadyPassed": "Quiz aprobado · mejor puntuación {score} %",
    "pathways.quiz.retry": "Intentar de nuevo",
    "pathways.quiz.attempts": "Intentos: {n}",
    "pathways.quiz.attemptsBest": "Intentos: {n} · mejor puntuación {best} %",
    "pathways.quiz.correct": "Correcta",
    "pathways.quiz.incorrect": "Incorrecta",
    "pathways.quiz.submitFailed": "No se pudieron enviar tus respuestas. Inténtalo de nuevo en un momento.",

    // ── phase 3 step kinds (contract §10) ──
    "pathways.kind.video": "Vídeo",
    "pathways.kind.reading": "Lectura",
    "pathways.kind.practice": "Práctica",
    "pathways.kind.quiz": "Quiz",
    "pathways.kind.live": "Sesión en directo",
    "pathways.kind.course": "Curso",

    // ── practice ──
    "pathways.practice.textLabel": "Tus notas",
    "pathways.practice.photoLabel": "Añadir una foto (opcional)",
    "pathways.practice.photoHint": "JPEG, PNG o WebP, 10 MB como máximo",
    "pathways.practice.photoRemove": "Quitar la foto",
    "pathways.practice.photoType": "Este tipo de foto no se admite. Elige una imagen JPEG, PNG o WebP.",
    "pathways.practice.photoTooLarge": "Esta foto supera los 10 MB. Elige una más ligera.",
    "pathways.practice.empty": "Escribe una nota o añade una foto antes de enviar.",
    "pathways.practice.submit": "Enviar",
    "pathways.practice.submitted": "Enviado. Tu terapeuta lo revisará.",
    "pathways.practice.submitFailed": "No se pudo enviar tu respuesta. Inténtalo de nuevo en un momento.",
    "pathways.practice.resubmitHint": "Puedes enviar una nueva respuesta cuando quieras: vuelve a tu terapeuta para su revisión.",
    "pathways.practice.submissions": "Tus envíos",
    "pathways.practice.submittedOn": "Enviado el {date}",
    "pathways.practice.status.pending": "Pendiente de revisión",
    "pathways.practice.status.approved": "Aprobado",
    "pathways.practice.status.feedback_sent": "Comentario recibido",
    "pathways.practice.status.superseded": "Sustituido por un envío más reciente",
    "pathways.practice.feedback": "Comentario de tu terapeuta",
    "pathways.practice.photoAlt": "Tu foto",

    // ── live session ──
    "pathways.live.duration": "{n} min",
    "pathways.live.zone": "Hora mostrada en tu zona horaria ({zone})",
    "pathways.live.timeTbd": "La fecha de esta sesión se anunciará pronto.",
    "pathways.live.addToCalendar": "Añadir al calendario",
    "pathways.live.attended": "Asistencia confirmada ✓",
    "pathways.live.attendanceHint": "Tu terapeuta registra la asistencia después de la sesión; el paso se completa entonces.",
    "pathways.live.free": "Gratis",
    "pathways.live.book": "Reservar esta sesión",
    "pathways.live.bookedFor": "Reservada para el {when}",
    "pathways.live.completesOnBooking": "Se completa cuando tu sesión se marca como completada",
    "pathways.live.completedSession": "Sesión del {when} completada",
    "pathways.live.serviceUnavailable": "Este tipo de sesión no se puede reservar por ahora. Contacta con tu terapeuta.",

    // ── course ──
    "pathways.course.lessons": "{done} de {total} lecciones",
    "pathways.course.open": "Abrir el curso",
    "pathways.course.unavailable": "Este curso no está disponible por ahora.",
    "pathways.course.completesHint": "Se completa cuando terminas todas las lecciones del curso.",
    "pathways.course.backToPathway": "Volver al itinerario",

    "pathways.nudges.title": "Recordatorios",
    "pathways.nudges.working": "Desactivando los recordatorios…",
    "pathways.nudges.done": "Ya no recibirás recordatorios de {title}.",
    "pathways.nudges.invalid": "Este enlace no es válido. Usa el enlace del último correo de recordatorio que recibiste.",
    "pathways.nudges.error": "No se pudieron desactivar los recordatorios. Inténtalo de nuevo en un momento.",
    "pathways.nudges.account": "Mi cuenta",

    "portal.pathways": "Mis itinerarios",
    "portal.pathways.empty": "Todavía no sigues ningún itinerario.",
    "portal.pathways.browse": "Descubrir los itinerarios",
    "portal.pathways.loadFailed": "No se pudieron cargar tus itinerarios. Inténtalo de nuevo en un momento.",
    "portal.pathways.open": "Abrir el itinerario",
    "portal.pathways.completed": "Completado",
    "portal.pathways.archived": "Archivado",
  },
};
